import type { PivotDateRange } from '@ztechapps/common.contract'

/** Whether a pivot member day (`YYYY-MM-DD`, local to the viewer) falls inside an inclusive date range — a blank member never matches. */
export const isInPivotDateRange = (memberKey: string, dateRange: PivotDateRange): boolean =>
  memberKey !== '' && dateRange.from <= memberKey && memberKey <= dateRange.to
